const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

export async function fetchEstudiantesBecas(params = {}) {
  let url = `${API_BASE}/escolar/reportes/estudiantes-becas/`;
  const query = new URLSearchParams(params).toString();
  if (query) url += `?${query}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error('Error al obtener becas');
  return res.json();
}
